// Importing necessary libraries, action types, and helper functions
import CryptoJS from "crypto-js"; // Library for encryption
import * as types from "./ActionTypes"; // Importing action type constants
import {
  post,
  get,
  getWithCache,
  getExport,
  getExport1,
  getApiPorject,
  exportApiLogs,
  postApiLogs,
  getWithCacheApiLogs,
  getExportJsonData,
  getUnmaskedJsonData,
  getUnmaskedJsonDataACH,
  getExportJsonDataACH,
  getExportfromFrontegg
} from "../Helper/index"; // Helper functions for API calls
import * as urls from "../../Uintls/Urls"; // Importing API endpoint URLs

// Action to fetch routing number data
export const getRoutingNumberData = (data) => (dispatch) => {
  const encryptionKey = process.env.REACT_APP_ENCRYPTION_ENVIRONMENT; // Environment variable for encryption
  const secretKey = process.env.REACT_APP_ENCRIPTION_KEY; // Secret key for encryption
  const encryptedPayload = CryptoJS.AES.encrypt(
    JSON.stringify(data), // Encrypt the payload
    secretKey
  ).toString();
  const payload = { payload: encryptedPayload }; // Encrypted payload
  dispatch({ type: types.ROUTING_NUMBER_CALL }); // Dispatch routing number call action
  return get({
    url: `${urls.ROUTING_NUMBER_URL}`, // API endpoint for routing number
    success: types.ROUTING_NUMBER_SUCCESS, // Action type for successful response
    failure: types.ROUTING_NUMBER_ERROR, // Action type for failed response
    dispatch, // Dispatch function
    body: encryptionKey === "NO" ? data : payload, // Use encrypted payload if encryption is enabled
  }).catch(() => {
    // Swallow rejected routing-number validation failures after Redux state already updated.
  });
};

// Action to fetch merchant group codes
export const getMerchantGroupCode = () => (dispatch) => {
  dispatch({ type: types.GET_MERCHANT_GROUP_CODE_LIST }); // Dispatch merchant group code list action
  getApiPorject({
    url: `${urls.GET_MERCHANT_GROUP_CODE_LIST}`, // API endpoint for merchant group codes
    success: types.GET_MERCHANT_GROUP_CODE_SUCCESS, // Action type for successful response
    failure: types.GET_MERCHANT_GROUP_CODE_ERROR, // Action type for failed response
    dispatch, // Dispatch function
  });
};

// Action to fetch merchant group code portfolios
export const getMerchantGroupCodePortfolios =
  (data) => (dispatch) => {
    const payload = {
      managerId: data?.managerId || data?.Manager_id || data?.Manager_Id || data?.Requested_by_id,
      businessId: data?.businessId || data?.Business_id || data?.Bussines_id || data?.Requested_for_id,
      email: data?.email || data?.primaryManagerEmail || data?.MainEmail,
    };

    dispatch({ type: types.GET_MERCHANT_GROUP_CODE_LIST_PORTFOLIOS }); // Dispatch merchant group code portfolios action
    getWithCacheApiLogs({
      url: `${urls.GET_MERCHANT_GROUP_CODE_LIST_PORTFOLIOS}`, // API endpoint for group code portfolios
      success: types.GET_MERCHANT_GROUP_CODE_LIST_PORTFOLIOS_SUCCESS, // Action type for successful response
      failure: types.GET_MERCHANT_GROUP_CODE_LIST_PORTFOLIOS_ERROR, // Action type for failed response
      dispatch, // Dispatch function
      body: payload, // Request query params
    });
  };

// Action to fetch RTP ACH data
export const getRtpAch = (data) => (dispatch) => {
  dispatch({ type: types.GET_RTP_ACH_LIST }); // Dispatch RTP ACH list action
  get({
    url: `${urls.GET_RTP_ACH_LIST}`, // API endpoint for RTP ACH
    success: types.GET_RTP_ACH_LIST_SUCCESS, // Action type for successful response
    failure: types.GET_RTP_ACH_LIST_ERROR, // Action type for failed response
    dispatch, // Dispatch function
    body: data, // Request body
  });
};

// Action to fetch manager personal information
export const getManagerPersonalInfo = (data) => (dispatch) => {
  const encryptionKey = process.env.REACT_APP_ENCRYPTION_ENVIRONMENT; // Environment variable for encryption
  const secretKey = process.env.REACT_APP_ENCRIPTION_KEY; // Secret key for encryption
  const encryptedPayload = CryptoJS.AES.encrypt(
    JSON.stringify(data), // Encrypt the payload
    secretKey
  ).toString();
  const payload = { payload: encryptedPayload }; // Encrypted payload
  dispatch({ type: types.MANAGER_PERSONAL_INFO_LIST }); // Dispatch manager personal info list action
  get({
    url: `${urls.MANAGER_PERSONAL_INFO_LIST}`, // API endpoint for manager personal info
    success: types.MANAGER_PERSONAL_INFO_LIST_SUCCESS, // Action type for successful response
    failure: types.MANAGER_PERSONAL_INFO_LIST_ERROR, // Action type for failed response
    dispatch, // Dispatch function
    body: encryptionKey === "NO" ? data : payload, // Use encrypted payload if encryption is enabled
  });
};

// Action to fetch account number data
export const getAccountNumberData = (data) => (dispatch) => {
  dispatch({ type: types.ACCOUNT_NUMBER_CALL }); // Dispatch account number call action
  get({
    url: `${urls.ACCOUNT_NUMBER_URL}`, // API endpoint for account number
    success: types.ACCOUNT_NUMBER_SUCCESS, // Action type for successful response
    failure: types.ACCOUNT_NUMBER_ERROR, // Action type for failed response
    dispatch, // Dispatch function
    body: data, // Request body
  }).catch(() => { });
};

// Action to confirm forget password
export const confirmForgetPassword = (data) => (dispatch) => {
  dispatch({ type: types.USER_FORGET_PASSWORD_CALL }); // Dispatch forget password call action
  get({
    url: `${urls.USER_FORGET_PASSWORD_URL}`, // API endpoint for forget password
    success: types.USER_FORGET_PASSWORD_SUCCESS, // Action type for successful response
    failure: types.USER_FORGET_PASSWORD_ERROR, // Action type for failed response
    dispatch, // Dispatch function
    body: data, // Request body
  });
};

// Action to check reset password authentication
export const checkResetPasswordAuthCall = (data) => (dispatch) => {
  dispatch({ type: types.CHECK_RESET_PASSWORD_AUTH_CHECK_CALL }); // Dispatch reset password auth check call action
  get({
    url: `${urls.CHECK_RESET_PASSWORD_AUTH_CHECK_URL}`, // API endpoint for reset password auth check
    success: types.CHECK_RESET_PASSWORD_AUTH_CHECK_SUCCESS, // Action type for successful response
    failure: types.CHECK_RESET_PASSWORD_AUTH_CHECK_ERROR, // Action type for failed response
    dispatch, // Dispatch function
    body: data, // Request body
  });
};

// Action to change user password
export const changePasswordCall = (data) => (dispatch) => {
  dispatch({ type: types.CHANGE_USER_PASSWORD_CALL }); // Dispatch change password call action
  get({
    url: `${urls.CHANGE_USER_PASSWORD_URL}`, // API endpoint for changing password
    success: types.CHANGE_USER_PASSWORD_SUCCESS, // Action type for successful response
    failure: types.CHANGE_USER_PASSWORD_ERROR, // Action type for failed response
    dispatch, // Dispatch function
    body: data, // Request body
  });
};

export const addProposalCall = (data) => (dispatch) => {
  dispatch({ type: types.ADD_PROPOSAL_DETAILS_CALL });
  post({
    url: `${urls.ADD_PROPOSAL_DETAILS_URL}`,
    success: types.ADD_PROPOSAL_DETAILS_SUCCESS,
    failure: types.ADD_PROPOSAL_DETAILS_ERROR,
    dispatch,
    body: data,
  });
};

export const setUpMonthlyOffer = (data) => ({
  type: types.SETUP_MONTHLY_FROM_OFFER,
  data,
});

export const setLoadingFalse = (data) => ({
  type: types.GENRATE_OFFER_LOADING_FALSE,
  data,
});

export const setDefaultOfferValue = (data) => ({
  type: types.SET_DEFAULT_VALUE_OFFER,
  data,
});

export const setBackToSearchFromDetails = () => ({
  type: types.SET_BACK_TO_SEARCH_FROM_OFFER,
});

export const emptyUserSelect = () => ({
  type: types.EMPTY_OFFER_SELECT_USER,
});

export const setUserIdResetPaassword = (data) => ({
  type: types.SET_USER_ID_FORGET_PASSWORD,
  data,
});

export const paymentTokenCheckout = (data) => (dispatch) => {
  dispatch({ type: types.PAYMENT_CHECKOUT_CALL });
  post({
    url: `${urls.PAYMENT_CHECKOUT_URL}`,
    success: types.PAYMENT_CHECKOUT_SUCCESS,
    failure: types.PAYMENT_CHECKOUT_ERROR,
    dispatch,
    body: data,
    auth: false,
    payment: true,
  });
};
export const getApiLogsDataFetchLogs = (data) => (dispatch) => {
  const { forceRefresh = false, ...requestPayload } = data || {};
  const encryptionKey = process.env.REACT_APP_ENCRYPTION_ENVIRONMENT;
  const secretKey = process.env.REACT_APP_ENCRIPTION_KEY;
  const encryptedPayload = CryptoJS.AES.encrypt(
    JSON.stringify(requestPayload),
    secretKey
  ).toString();
  const payload = { payload: encryptedPayload };
  dispatch({ type: types.GET_API_LOGS_FETCH_LOGS });
  postApiLogs({
    url: `${urls.GET_API_LOGS_FETCH_LOGS}`,
    success: types.GET_API_LOGS_FETCH_LOGS_SUCCESS,
    failure: types.GET_API_LOGS_FETCH_LOGS_ERROR,
    dispatch,
    body: encryptionKey === "NO" ? requestPayload : payload,
    noCache: forceRefresh,
  });
};

export const getApiLogsByIdDataFetchLogs = (data) => (dispatch) => {
  const encryptionKey = process.env.REACT_APP_ENCRYPTION_ENVIRONMENT;
  const secretKey = process.env.REACT_APP_ENCRIPTION_KEY;
  const encryptedPayload = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    secretKey
  ).toString();
  const payload = { payload: encryptedPayload };
  dispatch({ type: types.GET_API_LOGS_BY_ID_FETCH_LOGS });
  postApiLogs({
    url: `${urls.GET_API_LOGS_BY_ID_FETCH_LOGS}`,
    success: types.GET_API_LOGS_BY_ID_FETCH_LOGS_SUCCESS,
    failure: types.GET_API_LOGS_BY_ID_FETCH_LOGS_ERROR,
    dispatch,
    body: encryptionKey === "NO" ? data : payload,
  });
};

export const getApiLogsByIdDataFetchLogsNew =
  (payload, successCallback, failureCallback) => async () => {
    const encryptionKey = process.env.REACT_APP_ENCRYPTION_ENVIRONMENT;
    const secretKey = process.env.REACT_APP_ENCRIPTION_KEY;

    const encryptedPayload = CryptoJS.AES.encrypt(
      JSON.stringify(payload),
      secretKey
    ).toString();

    const payloadNew =
      encryptionKey === "NO"
        ? payload
        : { payload: encryptedPayload };

    try {
      const data = await getExportJsonDataACH(
        urls.GET_API_LOGS_BY_ID_FETCH_LOGS,
        payloadNew
      );

      if (typeof successCallback === "function") {
        successCallback(data);
      }
    } catch (err) {
      if (typeof failureCallback === "function") {
        failureCallback(err);
      }
    }
  };

export const getApiLogsDataExportNew =
  (payload, successCallback, failureCallback) => async () => {
    const encryptionKey = process.env.REACT_APP_ENCRYPTION_ENVIRONMENT;
    const secretKey = process.env.REACT_APP_ENCRIPTION_KEY;
    const encryptedPayload = CryptoJS.AES.encrypt(
      JSON.stringify(payload),
      secretKey
    ).toString();
    const payloadNew =
      encryptionKey === "NO" ? payload : { payload: encryptedPayload };

    try {
      const response = await exportApiLogs(
        urls.GET_API_LOGS_EXPORT_NEW,
        payloadNew
      );

      if (typeof successCallback === "function") {
        successCallback(response);
      }
    } catch (err) {
      console.error("Error downloading file:", err);
      if (typeof failureCallback === "function") {
        failureCallback(err);
      }
    }
  };

export const getMerchantListData = (data) => (dispatch) => {
  const encryptionKey = process.env.REACT_APP_ENCRYPTION_ENVIRONMENT;
  const secretKey = process.env.REACT_APP_ENCRIPTION_KEY;
  const encryptedPayload = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    secretKey
  ).toString();
  const payload = { payload: encryptedPayload };
  dispatch({ type: types.GET_MERCHANT_LIST });
  getWithCache({
    url: `${urls.GET_MERCHANT_LIST}`,
    success: types.GET_MERCHANT_LIST_SUCCESS,
    failure: types.GET_MERCHANT_LIST_ERROR,
    dispatch,
    body: encryptionKey === "NO" ? data : payload,
  });
};

export const getMerchantListDataName = (data) => (dispatch) => {
  const encryptionKey = process.env.REACT_APP_ENCRYPTION_ENVIRONMENT;
  const secretKey = process.env.REACT_APP_ENCRIPTION_KEY;
  const encryptedPayload = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    secretKey
  ).toString();
  const payload = { payload: encryptedPayload };
  dispatch({ type: types.GET_MERCHANT_LIST_NAMES });
  get({
    url: `${urls.GET_MERCHANT_LIST_NAMES}`,
    success: types.GET_MERCHANT_LIST_NAMES_SUCCESS,
    failure: types.GET_MERCHANT_LIST_NAMES_ERROR,
    dispatch,
    body: encryptionKey === "NO" ? data : payload,
  });
};

export const setFormData = (formData) => ({
  type: types.SET_FORM_DATA,
  payload: formData,
});

export const clearFormData = () => ({
  type: types.CLEAR_FORM_DATA,
});

export const getManagerListData = (data) => (dispatch) => {
  const encryptionKey = process.env.REACT_APP_ENCRYPTION_ENVIRONMENT;
  const secretKey = process.env.REACT_APP_ENCRIPTION_KEY;
  const encryptedPayload = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    secretKey
  ).toString();
  const payload = { payload: encryptedPayload };
  dispatch({ type: types.GET_MANAGER_LIST });
  getWithCache({
    url: `${urls.GET_MANAGER_LIST}`,
    success: types.GET_MANAGER_LIST_SUCCESS,
    failure: types.GET_MANAGER_LIST_ERROR,
    dispatch,
    body: encryptionKey === "NO" ? data : payload,
  });
};

export const getManagerActionsData = (data) => (dispatch) => {
  dispatch({ type: types.GET_MANAGER_ACTIONS_LIST });
  get({
    url: `${urls.GET_MANAGER_ACTIONS_LIST}`,
    success: types.GET_MANAGER_ACTIONS_LIST_SUCCESS,
    failure: types.GET_MANAGER_ACTIONS_LIST_ERROR,
    dispatch,
    body: data,
  });
};

export const getManagerListDataByID = (data) => (dispatch) => {
  const encryptionKey = process.env.REACT_APP_ENCRYPTION_ENVIRONMENT;
  const secretKey = process.env.REACT_APP_ENCRIPTION_KEY;
  const encryptedPayload = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    secretKey
  ).toString();
  const payload = { payload: encryptedPayload };
  dispatch({ type: types.GET_MANAGER_LIST_BY_ID });
  get({
    url: `${urls.GET_MANAGER_LIST}`,
    success: types.GET_MANAGER_LIST_SUCCESS_BY_ID,
    failure: types.GET_MANAGER_LIST_ERROR_BY_ID,
    dispatch,
    body: encryptionKey === "NO" ? data : payload,
  });
};

export const getManagerListDataNames = (data) => (dispatch) => {
  const encryptionKey = process.env.REACT_APP_ENCRYPTION_ENVIRONMENT;
  const secretKey = process.env.REACT_APP_ENCRIPTION_KEY;
  const encryptedPayload = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    secretKey
  ).toString();
  const payload = { payload: encryptedPayload };
  dispatch({ type: types.GET_MANAGER_LIST_NAMES });
  get({
    url: `${urls.GET_MANAGER_LIST}`,
    success: types.GET_MANAGER_LIST_NAMES_SUCCESS,
    failure: types.GET_MANAGER_LIST_NAMES_ERROR,
    dispatch,
    body: encryptionKey === "NO" ? data : payload,
  });
};

export const setFormDataManager = (formDataManager) => ({
  type: types.SET_FORM_DATA_MANAGER,
  payload: formDataManager,
});

export const clearFormDataManager = () => ({
  type: types.CLEAR_FORM_DATA_MANAGER,
});

export const getTransactionListData = (data) => (dispatch) => {
  const encryptionKey = process.env.REACT_APP_ENCRYPTION_ENVIRONMENT;
  const secretKey = process.env.REACT_APP_ENCRIPTION_KEY;
  const encryptedPayload = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    secretKey
  ).toString();
  const payload = { payload: encryptedPayload };
  dispatch({ type: types.GET_MANAGER_LIST });
  getWithCacheApiLogs({
    url: `${urls.GET_TRANSACTION_LIST}`,
    success: types.GET_TRANSACTION_LIST_SUCCESS,
    failure: types.GET_TRANSACTION_LIST_ERROR,
    dispatch,
    body: encryptionKey === "NO" ? data : payload,
  });
};

export const getApiLogsData = (data) => (dispatch) => {
  const { forceRefresh = false, ...requestPayload } = data || {};
  const encryptionKey = process.env.REACT_APP_ENCRYPTION_ENVIRONMENT;
  const secretKey = process.env.REACT_APP_ENCRIPTION_KEY;
  const encryptedPayload = CryptoJS.AES.encrypt(
    JSON.stringify(requestPayload),
    secretKey
  ).toString();
  const payload = { payload: encryptedPayload };
  dispatch({ type: types.GET_API_LOGS });
  getWithCacheApiLogs({
    url: `${urls.GET_API_LOGS}`,
    success: types.GET_API_LOGS_SUCCESS,
    failure: types.GET_API_LOGS_ERROR,
    dispatch,
    body: encryptionKey === "NO" ? requestPayload : payload,
    noCache: forceRefresh,
  });
};

export const getErrorCodeData = (data) => (dispatch) => {
  dispatch({ type: types.GET_ERROR_CODE });
  getWithCache({
    url: `${urls.GET_ERROR_CODE}`,
    success: types.GET_ERROR_CODE_SUCCESS,
    failure: types.GET_ERROR_CODE_ERROR,
    dispatch,
    body: data,
  });
};

export const getErrorCodeExport =
  (payload, successCallback, failureCallback) => async () => {
    try {
      const data = await getExport1(urls.GET_ERROR_CODE, payload);

      if (typeof successCallback === "function") {
        successCallback(data);
      }
    } catch (err) {
      if (typeof failureCallback === "function") {
        failureCallback(err);
      }
    }
  };
export const getApiLogsDataExport =
  (payload, successCallback, failureCallback) => async () => {
    const encryptionKey = process.env.REACT_APP_ENCRYPTION_ENVIRONMENT;
    const secretKey = process.env.REACT_APP_ENCRIPTION_KEY;
    const encryptedPayload = CryptoJS.AES.encrypt(
      JSON.stringify(payload),
      secretKey
    ).toString();
    let payloadNew = {};
    if (encryptionKey === "NO") {
      payloadNew = payload;
    } else {
      payloadNew = { payload: encryptedPayload };
    }
    try {
      const data = await getExportfromFrontegg(urls.GET_API_LOGS, payloadNew);

      if (typeof successCallback === "function") {
        successCallback(data);
      }
    } catch (err) {
      if (typeof failureCallback === "function") {
        failureCallback(err);
      }
    }
  };

export const getApiLogsJsonData =
  (payload, successCallback, failureCallback) => async () => {
    const encryptionKey = process.env.REACT_APP_ENCRYPTION_ENVIRONMENT;
    const secretKey = process.env.REACT_APP_ENCRIPTION_KEY;
    const encryptedPayload = CryptoJS.AES.encrypt(
      JSON.stringify(payload),
      secretKey
    ).toString();
    let payloadNew = {};
    if (encryptionKey === "NO") {
      payloadNew = payload;
    } else {
      payloadNew = { payload: encryptedPayload };
    }
    try {
      const data = await getExportJsonData(urls.GET_API_LOGS, payloadNew);

      if (typeof successCallback === "function") {
        successCallback(data);
      }
    } catch (err) {
      if (typeof failureCallback === "function") {
        failureCallback(err);
      }
    }
  };

export const getDecryptedApiLogsJsonData =
  (payload, successCallback, failureCallback) => async () => {
    const encryptionKey = process.env.REACT_APP_ENCRYPTION_ENVIRONMENT;
    const secretKey = process.env.REACT_APP_ENCRIPTION_KEY;
    const encryptedPayload = CryptoJS.AES.encrypt(
      JSON.stringify(payload),
      secretKey
    ).toString();
    let payloadNew = {};
    if (encryptionKey === "NO") {
      payloadNew = payload;
    } else {
      payloadNew = { payload: encryptedPayload };
    }
    try {
      const data = await getUnmaskedJsonData(urls.GET_DECRYPTED_JSON, payloadNew);

      if (typeof successCallback === "function") {
        successCallback(data);
      }
    } catch (err) {
      if (typeof failureCallback === "function") {
        failureCallback(err);
      }
    }
  };

export const getDecryptedApiLogsJsonDataACH =
  (payload, successCallback, failureCallback) => async () => {
    const encryptionKey = process.env.REACT_APP_ENCRYPTION_ENVIRONMENT;
    const secretKey = process.env.REACT_APP_ENCRIPTION_KEY;
    const encryptedPayload = CryptoJS.AES.encrypt(
      JSON.stringify(payload),
      secretKey
    ).toString();
    let payloadNew = {};
    if (encryptionKey === "NO") {
      payloadNew = payload;
    } else {
      payloadNew = { payload: encryptedPayload };
    }
    try {
      const data = await getUnmaskedJsonDataACH(urls.GET_DECRYPTED_JSON_ACH, payloadNew);

      if (typeof successCallback === "function") {
        successCallback(data);
      }
    } catch (err) {
      if (typeof failureCallback === "function") {
        failureCallback(err);
      }
    }
  };

export const getApiLogsDataJson =
  (payload, successCallback, failureCallback) => async () => {
    const encryptionKey = process.env.REACT_APP_ENCRYPTION_ENVIRONMENT;
    const secretKey = process.env.REACT_APP_ENCRIPTION_KEY;
    const encryptedPayload = CryptoJS.AES.encrypt(
      JSON.stringify(payload),
      secretKey
    ).toString();
    let payloadNew = {};
    if (encryptionKey === "NO") {
      payloadNew = payload;
    } else {
      payloadNew = { payload: encryptedPayload };
    }
    try {
      const data = await getExport1(urls.GET_API_LOGS, payloadNew);

      if (typeof successCallback === "function") {
        successCallback(data);
      }
    } catch (err) {
      if (typeof failureCallback === "function") {
        failureCallback(err);
      }
    }
  };

export const getRefundHistoryDataExport =
  (payload, successCallback, failureCallback) => async () => {
    try {
      const data = await getExport1(urls.GET_TRANSACTION_HISTORY, payload);

      if (typeof successCallback === "function") {
        successCallback(data);
      }
    } catch (err) {
      if (typeof failureCallback === "function") {
        failureCallback(err);
      }
    }
  };

export const getTransactionListDataExport =
  (payload, successCallback, failureCallback) => async () => {
    const encryptionKey = process.env.REACT_APP_ENCRYPTION_ENVIRONMENT;
    const secretKey = process.env.REACT_APP_ENCRIPTION_KEY;
    const encryptedPayload = CryptoJS.AES.encrypt(
      JSON.stringify(payload),
      secretKey
    ).toString();
    let payloadNew = {};
    if (encryptionKey === "NO") {
      payloadNew = payload;
    } else {
      payloadNew = { payload: encryptedPayload };
    }

    try {
      const data = await getExportfromFrontegg(urls.GET_TRANSACTION_LIST, payloadNew);
      if (typeof successCallback === "function") {
        successCallback(data);
      }
    } catch (err) {
      if (typeof failureCallback === "function") {
        failureCallback(err);
      }
    }
  };
export const getMerchantSetupDataExport =
  (payload, successCallback, failureCallback) => async () => {
    const encryptionKey = process.env.REACT_APP_ENCRYPTION_ENVIRONMENT;
    const secretKey = process.env.REACT_APP_ENCRIPTION_KEY;
    const encryptedPayload = CryptoJS.AES.encrypt(
      JSON.stringify(payload),
      secretKey
    ).toString();
    let payloadNew = {};
    if (encryptionKey === "NO") {
      payloadNew = payload;
    } else {
      payloadNew = { payload: encryptedPayload };

      // payloadNew = { encryptedPayload };
    }
    try {
      const data = await getExport(urls.GET_MERCHANT_LIST, payloadNew);
      if (typeof successCallback === "function") {
        successCallback(data);
      }
    } catch (err) {
      if (typeof failureCallback === "function") {
        failureCallback(err);
      }
    }
  };

export const getMerchantListDataExport =
  (payload, successCallback, failureCallback) => async () => {
    const secretKey = process.env.REACT_APP_ENCRIPTION_KEY;
    const encryptionKey = process.env.REACT_APP_ENCRYPTION_ENVIRONMENT;
    const encryptedPayload = CryptoJS.AES.encrypt(
      JSON.stringify(payload),
      secretKey
    ).toString();
    let payloadNew = {};
    if (encryptionKey === "NO") {
      payloadNew = payload;
    } else {
      payloadNew = { payload: encryptedPayload };

      // payloadNew = { encryptedPayload };
    }
    try {
      const data = await getExport(urls.GET_MANAGER_LIST, payloadNew);

      if (typeof successCallback === "function") {
        successCallback(data);
      }
    } catch (err) {
      if (typeof failureCallback === "function") {
        failureCallback(err);
      }
    }
  };

export const setFormDataApiLogs = (formDataApiLogs) => ({
  type: types.SET_FORM_DATA_API_LOGS,
  payload: formDataApiLogs,
});

export const clearFormDataApiLogs = () => ({
  type: types.CLEAR_FORM_DATA_API_LOGS,
});

export const setFormDataErrorCodes = (formDataErrorCodes) => ({
  type: types.SET_FORM_DATA_ERROR_CODES,
  payload: formDataErrorCodes,
});

export const clearFormDataErrorCodes = () => ({
  type: types.CLEAR_FORM_DATA_ERROR_CODES,
});

export const emptyReduxState = () => ({
  type: types.EMPTY_REDUX_STATE,
});

export const emptyMerchantRTNReduxState = () => ({
  type: types.EMPTY_MERCHANT_RTN_REDUX_STATE,
});

export const emptyGroupCodeReduxState = () => ({
  type: types.EMPTY_GROUP_CODE_LIST_REDUX_STATE,
});

export const emptyMerchantAccReduxState = () => ({
  type: types.EMPTY_MERCHANT_ACC_REDUX_STATE,
});

export const getTransactionHistoryData = (data) => (dispatch) => {
  dispatch({ type: types.GET_TRANSACTION_HISTORY });
  getWithCacheApiLogs({
    url: `${urls.GET_TRANSACTION_HISTORY}`,
    success: types.GET_TRANSACTION_HISTORY_SUCCESS,
    failure: types.GET_TRANSACTION_HISTORY_ERROR,
    dispatch,
    body: data,
  });
};

export const setFormDataTransactionHistory = (
  searchDataTransactionHistory
) => ({
  type: types.SET_FORM_DATA_TRANSACTION_HISTORY,
  payload: searchDataTransactionHistory,
});

export const clearFormDataTransactionHistory = () => ({
  type: types.CLEAR_FORM_DATA_TRANSACTION_HISTORY,
});

export const setTransactionListPage = (page) => ({
  type: "SET_TRANSACTION_LIST_PAGE",
  payload: page,
});

export const setTransactionListRowsPerPage = (rowsPerPage) => ({
  type: "SET_TRANSACTION_LIST_ROWS_PER_PAGE",
  payload: rowsPerPage,
});

export const getEmailList = (query, type) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: "GET_EMAIL_LIST" });

    const encodedQuery = encodeURIComponent(query);

    get({
      url: `${urls.GET_EMAIL_LIST_URL}?q=${encodedQuery}&type=${type}`,
      success: types.GET_EMAIL_LIST_SUCCESS,
      failure: types.GET_EMAIL_LIST_ERROR,
      dispatch,
    })
      .then((data) => resolve(data))
      .catch((error) => reject(error));
  });

export const getEmailData = (query) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: "GET_EMAIL_DATA" });

    const encodedQuery = encodeURIComponent(query);

    get({
      url: `${urls.GET_EMAIL_DATA_URL}?email=${encodedQuery}`,
      success: types.GET_EMAIL_DATA_SUCCESS,
      failure: types.GET_EMAIL_DATA_ERROR,
      dispatch,
    })
      .then((data) => resolve(data))
      .catch((error) => reject(error));
  });

export const getEmailData1 = (query) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: "GET_EMAIL_DATA1" });

    const encodedQuery = encodeURIComponent(query);

    get({
      url: `${urls.GET_EMAIL_DATA_URL}?email=${encodedQuery}`,
      success: types.GET_EMAIL_DATA1_SUCCESS,
      failure: types.GET_EMAIL_DATA1_ERROR,
      dispatch,
    })
      .then((data) => {
        resolve(data);
        localStorage.setItem("emailData1", JSON.stringify(data));
      })
      .catch((error) => reject(error));
  });

export const emptyEmailListReduxState = () => ({
  type: types.EMPTY_EMAIL_LIST_REDUX_STATE,
});

export const setMerchantListPage = (page) => ({
  type: "SET_MERCHANT_LIST_PAGE",
  payload: page,
});

export const setMerchantListRowsPerPage = (rowsPerPage) => ({
  type: "SET_MERCHANT_LIST_ROWS_PER_PAGE",
  payload: rowsPerPage,
});
